<mat-card class="card borderradius-bottom-none">
  <div class="header">
    <h1 class="title">{{ 'request.header.title' | translate }} {{ numRequest }}</h1>
    <mat-chip-list>
      <mat-chip [ngClass]="stateClass"> {{ stateName | translate }} </mat-chip>
    </mat-chip-list>
    <h1 class="subtitle">{{ operative }}</h1>
    <mat-icon *ngIf="isEnabledVideoselfing()" class="camera-icon">camera_alt</mat-icon>
    <h3 class="videoselfing" *ngIf="isEnabledVideoselfing()">VIDEO_IDENTIF</h3>
  </div>
  <div class="subTitle">
    <p translate>request.header.text</p>
  </div>
</mat-card>
